import React, { useEffect, useState } from 'react';
import './index.css';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import { connect } from 'react-redux';
import { editClass, removeClassFromTeacher } from '../../../../redux';

function ClassTile (props) {
    const [state, setState] = useState({
        editClicked: false,
        name: "",
        status: "",
        errMsg: ""
    });

    useEffect(() => {
        setState({
            ...state,
            name: props.thisClassObject.name,
            status: props.thisClassObject.status
        })
    }, []);

    const toggleEditClicked = () => {
        setState({
            ...state,
            editClicked: !state.editClicked,
        });
    }

    const handleDropdownChange = (e) => {
        setState({
            ...state,
            status: e.target.innerText.trim()
        });
    }

    const handleChange = (e) => {
        setState({
            ...state,
            name: e.target.value
        });
    }

    const handleRemoveClick = () => {
        const userId = props.user._id;

        props.removeClassFromTeacher(userId, props.thisClassObject._id, props.teacherClasses);
        setState({
            ...state,
            errMsg: ""
        });
    }

    const handleEdit = () => {
        if (state.name === "" ||
            state.status === "") {
            setState({
                ...state,
                errMsg: "Please fill out all the fields."
            })
        } else {
            props.editClass(
                {
                    name: state.name,
                    status: state.status
                },
                props.teacherClasses,
                props.possibleClasses,
                props.thisClassObject._id
            );
            setState({
                ...state,
                editClicked: false,
                errMsg: ""
            });
        }
    }

    const handleArchive = () => {
        props.onArchiveClick(props.thisClassObject);
    }

    if (state.editClicked) {
        return (
            <div className="classTileContainer">
                <div className="classTile">
                    <TextField
                        hintText="Class Name"
                        name="name"
                        value={state.name}
                        onChange={handleChange}
                        fullWidth={true}
                        style={{paddingLeft: "0"}}
                    />

                    <SelectField
                        hintText={"Class Status"}
                        name="status"
                        value={state.status}
                        onChange={handleDropdownChange}
                        fullWidth={true}
                    >
                        <MenuItem
                            key={"Active"}
                            value={"Active"}
                            primaryText={"Active"}
                            id="status"
                        />
                        <MenuItem
                            key={"Closed"}
                            value={"Closed"}
                            primaryText={"Closed"}
                            id="status"
                        />
                    </SelectField>
                    <div style={{display: "flex", gap: "10px"}}>
                        <button onClick={toggleEditClicked} className="actionButton" style={{display: "block"}}>Cancel</button>
                        <button onClick={handleEdit} className="pink">Save</button>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <div className="classTileContainer">
            <div className="classTile">
                <h1>{props.thisClassObject.name}</h1>
                <h3>{props.thisClassObject.status}</h3>
                <button onClick={toggleEditClicked} className="pink">
                    Edit
                </button>
                <button onClick={handleRemoveClick} className="pink">
                    Unsubscribe
                </button>
                {props.thisClassObject.status === "Closed" ? (
                    <button onClick={handleArchive} className="pink">
                        Archive
                    </button>
                ) : null}
                <p className="errorMessage">{state.errMsg}</p>
            </div>
        </div>
    )
}

export default connect(state => state.root, { editClass, removeClassFromTeacher })(ClassTile);
